import Lenis from '@studio-freight/lenis'

export let lenisScroll = null

const smoothScroll = {
  init(): void {
    lenisScroll = new Lenis({
      lerp: 0.1,
    })

    function raf(time) {
      lenisScroll.raf(time)
      requestAnimationFrame(raf)
    }

    requestAnimationFrame(raf)
  },
}

export default smoothScroll
